import React, { useEffect, useState, createElement } from 'react';
import { MailIcon, ArrowLeftIcon, CalendarIcon, PresentationIcon, ArrowRightIcon, PlayCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
declare global {
  interface Window {
    Tally?: {
      openPopup: (formId: string, options?: Record<string, any>) => void;
      closePopup: (formId: string) => void;
    };
  }
}
export function InvestorDeckPage() {
  const [tallyReady, setTallyReady] = useState(false);
  useEffect(() => {
    if (window.Tally) {
      setTallyReady(true);
      return;
    }
    const loadTally = () => {
      const existing = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
      if (existing) {
        const interval = setInterval(() => {
          if (window.Tally) {
            setTallyReady(true);
            clearInterval(interval);
          }
        }, 200);
        setTimeout(() => clearInterval(interval), 10000);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      script.onload = () => {
        const interval = setInterval(() => {
          if (window.Tally) {
            setTallyReady(true);
            clearInterval(interval);
          }
        }, 100);
        setTimeout(() => clearInterval(interval), 5000);
      };
      document.head.appendChild(script);
    };
    loadTally();
  }, []);
  const openInvestorForm = () => {
    if (window.Tally) {
      window.Tally.openPopup('44258r', {
        layout: 'modal',
        width: 700,
        autoClose: 5000
      });
    } else {
      window.open('https://tally.so/r/44258r', '_blank');
    }
  };
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-3022" data-mp="xk1et65lrbvl">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-3023" data-mp="1l9lzpulbgj7i">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-14 md:h-16 flex items-center justify-between" data-id="element-3024" data-mp="1q2yllwym2bwk">
          <div className="flex items-center space-x-2 md:space-x-4 min-w-0" data-id="element-3025" data-mp="1zwuc2yqd2ul2">
            <Link to="/" className="text-gray-500 hover:text-[#631bb7] transition-colors shrink-0" data-id="element-3026" data-mp="1uyaoyv017cr4">
              <ArrowLeftIcon size={18} data-id="element-3027" data-mp="1pxwihhe2wav7" />
            </Link>
            <div className="h-5 w-px bg-gray-200 shrink-0" data-id="element-3028" data-mp="1lyw2e6mzjmbw"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-5 md:h-6 shrink-0" data-id="element-3029" data-mp="1m0guzqpqov74" />
            <span className="bg-gray-100 text-gray-600 text-[10px] md:text-xs font-semibold px-1.5 md:px-2 py-0.5 md:py-1 rounded-full uppercase tracking-wide shrink-0 hidden sm:inline-block" data-id="element-3030" data-mp="17981h6ipupop">
              Investor Portal
            </span>
          </div>
          <Link to="/invest" className="bg-[#631bb7] text-white px-4 py-2 rounded-lg font-medium text-sm hover:bg-[#521099] transition-colors shrink-0 no-underline" data-id="element-3031" data-mp="y80f9mth5faz">
            Invest
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 md:px-6 py-6 md:py-8 space-y-6 md:space-y-8" data-id="element-3032" data-mp="39vdn4jz5qd7f">
        {/* Welcome / Hero */}
        <section className="text-center max-w-3xl mx-auto" data-id="element-3033" data-mp="3dys5viehd7ok">
          <h1 className="text-[2rem] md:text-[3.25rem] font-semibold text-[#111111] leading-[1.15] tracking-tight mb-2 md:mb-3" data-id="element-3034" data-mp="3iwbkijf3bmh1">
            Welcome to the Caveo Investor Portal
          </h1>
          <p className="text-base md:text-lg text-gray-500 leading-relaxed" data-id="element-3035" data-mp="2q7w884ncfi9e">
            Access our strategic overview and product roadmap as we redefine
            family digital safety.
          </p>
        </section>

        {/* Video Overview */}
        <section className="mx-auto" data-id="element-3036" data-mp="2zzacepq8p68v">
          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-3037" data-mp="22ibm5cvw84vw">
            <div className="flex items-center gap-3 px-5 py-3 border-b border-gray-100 bg-gray-50" data-id="element-3038" data-mp="22gh8mjmybf1u">
              <PlayCircleIcon size={18} className="text-[#631bb7]" data-id="element-3039" data-mp="dypa95w89dhs" />
              <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2]" data-id="element-3040" data-mp="dyxop2800qv3">
                Video Overview
              </h2>
            </div>
            <div className="w-full relative" style={{
            paddingBottom: '56.25%',
            height: 0
          }} data-id="element-3041" data-mp="ms17zr5brxxn">
              <iframe src="https://drive.google.com/file/d/16XEJ5YgzcR2ffQXuc6t07ucUXlRq1lVf/preview" allow="autoplay" allowFullScreen className="absolute top-0 left-0 w-full h-full border-0" title="Caveo Overview Video" data-id="element-3042" data-mp="wonqi9a6icwi" />
            </div>
          </div>
        </section>

        {/* Review — 4 visual cards */}
        <section className="mx-auto" data-id="element-3043" data-mp="37ggorez6ebjp">
          <p className="text-[10px] md:text-xs font-medium text-gray-400 uppercase tracking-wider mb-2 md:mb-3" data-id="element-3044" data-mp="37hi9yc9woef5">
            Review
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-3045" data-mp="2tb6kzs897fn0">
            {/* Row 1: Business Plan + Market Research */}
            {/* Business Plan Card */}
            <Link to="/investor-plan" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all no-underline overflow-hidden flex flex-col" data-id="element-3046" data-mp="2xf4muaoyr4jr">
              <div className="p-4 pb-3" data-id="element-3047" data-mp="29mxsti6pn9ni">
                <p className="font-bold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-3048" data-mp="29q23myeol3n5">
                  Business Plan
                </p>
                <h2 className="text-sm md:text-base font-normal text-[#111111] leading-snug mb-3" data-id="element-3049" data-mp="20ocdrx0g6crh">
                  Read an abridged version of our business plan
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-medium text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-3050" data-mp="3v0shor5rtet6">
                  View Plan
                </span>
              </div>
              <div className="flex-1 px-3 pb-3 flex flex-col justify-end" data-id="element-3051" data-mp="1hf6peb9emmy">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 h-[140px]" data-id="element-3052" data-mp="3tj3jjs4mqnuw">
                  <img src="https://cdn.magicpatterns.com/uploads/1zrCQ9Gr3ZYbFmE2483dQT/Screenshot_2026-03-09_at_1.30.11_AM.png" alt="Business Plan preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300 brightness-[0.92] saturate-[0.85]" data-id="element-3053" data-mp="3ollbe3yfscny" />
                </div>
              </div>
            </Link>

            {/* Market Research Card */}
            <Link to="/investor-research" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all no-underline overflow-hidden flex flex-col" data-id="element-3054" data-mp="6e5k1tvoj44o">
              <div className="p-4 pb-3" data-id="element-3055" data-mp="z21h4zp5uy1z">
                <p className="font-bold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-3056" data-mp="16g2amrg29xpj">
                  Market Research
                </p>
                <h2 className="text-sm md:text-base font-normal text-[#111111] leading-snug mb-3" data-id="element-3057" data-mp="1bfwz6ocd6b7f">
                  Review our market validation report
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-medium text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-3058" data-mp="1ldkvvjtj5ss8">
                  View Report
                </span>
              </div>
              <div className="flex-1 px-3 pb-3 flex flex-col justify-end" data-id="element-3059" data-mp="1z3y4loe8xbim">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 h-[140px]" data-id="element-3060" data-mp="1z60rw0o0kqjn">
                  <img src="https://cdn.magicpatterns.com/uploads/oqzJtp6qNhMqD6TrzSPWrV/Screenshot_2026-03-09_at_8.32.13_AM.png" alt="Market Research preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300 brightness-[0.92] saturate-[0.85]" data-id="element-3061" data-mp="244lsw2b3be95" />
                </div>
              </div>
            </Link>

            {/* Row 2: Product Overview + Current Roadmap */}
            {/* Product Overview Card */}
            <Link to="/investor-overview" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all no-underline overflow-hidden flex flex-col" data-id="element-3062" data-mp="33eip7fztjrt6">
              <div className="p-4 pb-3" data-id="element-3063" data-mp="2pdppmgunu6j7">
                <p className="font-bold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-3064" data-mp="2percrjoyajha">
                  Product Overview
                </p>
                <h2 className="text-sm md:text-base font-normal text-[#111111] leading-snug mb-3" data-id="element-3065" data-mp="1wxf2go1thcgt">
                  Review our approach & offering
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-medium text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-3066" data-mp="1ry24b75hwiyx">
                  View Overview
                </span>
              </div>
              <div className="flex-1 px-3 pb-3 flex flex-col justify-end" data-id="element-3067" data-mp="3ul95b19zjf56">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 h-[140px]" data-id="element-3068" data-mp="3uj637ivk5vk3">
                  <img src="https://cdn.magicpatterns.com/uploads/93CQkpzDHgFWnEcf4Lj9VY/Solution_Tile.png" alt="Product Overview preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300 brightness-[0.92] saturate-[0.85]" data-id="element-3069" data-mp="2eu81gdukp2l" />
                </div>
              </div>
            </Link>

            {/* Current Roadmap Card */}
            <Link to="/investor-roadmap" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all no-underline overflow-hidden flex flex-col" data-id="element-3070" data-mp="31uqrp6bmxvdi">
              <div className="p-4 pb-3" data-id="element-3071" data-mp="2iijkckx94t1r">
                <p className="font-bold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-3072" data-mp="2ii9wb2vrovyp">
                  Current Roadmap
                </p>
                <h2 className="text-sm md:text-base font-normal text-[#111111] leading-snug mb-3" data-id="element-3073" data-mp="29q7up19yp9mu">
                  Review our product roadmap
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-medium text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-3074" data-mp="1uvbjqgarq862">
                  View Roadmap
                </span>
              </div>
              <div className="flex-1 px-3 pb-3 flex flex-col justify-end" data-id="element-3075" data-mp="1qr3ri953qa33">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 h-[140px]" data-id="element-3076" data-mp="3g6jz3k3dnnqv">
                  <img src="https://cdn.magicpatterns.com/uploads/h36X9PXxxPnRR1zyfhF4pm/Roadmap.png" alt="Current Roadmap preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300 brightness-[0.92] saturate-[0.85]" data-id="element-3077" data-mp="3l5d22il1fwcs" />
                </div>
              </div>
            </Link>
          </div>
        </section>

        {/* Next Steps */}
        <section className="mx-auto" data-id="element-3078" data-mp="33oa9djiisj6">
          <p className="text-[10px] md:text-xs font-medium text-gray-400 uppercase tracking-wider mb-2 md:mb-3" data-id="element-3079" data-mp="hu5jvk6awor5">
            Next Steps
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-3080" data-mp="cvc7jv2r33sk">
            {/* Email Us */}
            <a href="mailto:jbp@caveohq.com" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all p-5 md:p-6 flex flex-col items-center text-center no-underline" data-id="element-3081" data-mp="qt94wtp13e8a">
              <div className="w-10 h-10 bg-[#f0ebf8] rounded-full flex items-center justify-center mb-3 shrink-0" data-id="element-3082" data-mp="2ompjp7pbc1cg">
                <MailIcon size={20} className="text-[#631bb7]" data-id="element-3083" data-mp="rmbooi48smvo" />
              </div>
              <h3 className="font-bold text-base text-[#111111] mb-2" data-id="element-3084" data-mp="wk3nlw3b199d">
                Email Us
              </h3>
              <p className="text-xs text-gray-500 mb-4 flex-1" data-id="element-3085" data-mp="11kre8gnmfo32">
                Send us a due diligence question or request additional
                materials.
              </p>
              <span className="bg-[#631bb7] text-white w-full text-center rounded-lg font-medium text-sm py-2.5 group-hover:bg-[#521099] transition-colors block" data-id="element-3086" data-mp="1aitmnh9opj0d">
                Send Email
              </span>
            </a>

            {/* Book a Meeting */}
            <a href="https://calendar.app.google/EnoqEH7z4cY89jjN8" target="_blank" rel="noopener noreferrer" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all p-5 md:p-6 flex flex-col items-center text-center no-underline" data-id="element-3087" data-mp="1p8sfr5mdu48z">
              <div className="w-10 h-10 bg-[#f0ebf8] rounded-full flex items-center justify-center mb-3 shrink-0" data-id="element-3088" data-mp="3ion5mmoieiso">
                <CalendarIcon size={20} className="text-[#631bb7]" data-id="element-3089" data-mp="39q1moqf4l1rd" />
              </div>
              <h3 className="font-bold text-base text-[#111111] mb-2" data-id="element-3090" data-mp="34r6wh3etwax8">
                Book a Meeting
              </h3>
              <p className="text-xs text-gray-500 mb-4 flex-1" data-id="element-3091" data-mp="6a2x2f4kkfvd">
                Schedule a deep dive into our product roadmap and strategy.
              </p>
              <span className="bg-[#631bb7] text-white w-full text-center rounded-lg font-medium text-sm py-2.5 group-hover:bg-[#521099] transition-colors block" data-id="element-3092" data-mp="1ckxhfcfzd01">
                Schedule Now
              </span>
            </a>

            {/* Invest Now */}
            <Link to="/invest" className="group bg-[#fafafa] rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-[#8b5dc8] transition-all p-5 md:p-6 flex flex-col items-center text-center no-underline w-full" data-id="element-3093" data-mp="p144lrjr9jqj">
              <div className="w-10 h-10 bg-[#f0ebf8] rounded-full flex items-center justify-center mb-3 shrink-0" data-id="element-3094" data-mp="8tft6alrxulv">
                <ArrowRightIcon size={20} className="text-[#631bb7]" data-id="element-3095" data-mp="3qzcero0i4ahm" />
              </div>
              <h3 className="font-bold text-base text-[#111111] mb-2" data-id="element-3096" data-mp="3vx46oi15bwlt">
                Invest Now
              </h3>
              <p className="text-xs text-gray-500 mb-4 flex-1" data-id="element-3097" data-mp="nividm5nprzg">
                Review disclosures, the SAFE agreement, and submit your
                interest.
              </p>
              <span className="bg-[#631bb7] text-white w-full text-center rounded-lg font-medium text-sm py-2.5 group-hover:bg-[#521099] transition-colors block" data-id="element-3098" data-mp="dsj0y2t52exj">
                Get Started
              </span>
            </Link>
          </div>
        </section>

        {/* Pitch Deck */}
        <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mx-auto" data-id="element-3099" data-mp="1b751ggbhk1mw">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-gray-100 bg-gray-50" data-id="element-3100" data-mp="2vxaashsv3kc0">
            <PresentationIcon size={18} className="text-[#631bb7]" data-id="element-3101" data-mp="2qz8wea6ds96v" />
            <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2]" data-id="element-3102" data-mp="2qwwd9tovzss8">
              Pitch Deck
            </h2>
          </div>
          <div className="w-full" style={{
          aspectRatio: '16/9'
        }} data-id="element-3103" data-mp="30p26f6qvkg90">
            <iframe src="https://docs.google.com/presentation/d/1DDAemu62thxS5XgH-nUiftFnvyhFoQviVl-XCZ8Ijuo/embed?start=false&loop=false&delayms=3000" className="w-full h-full border-0" allowFullScreen title="Caveo Pitch Deck" data-id="element-3104" data-mp="2d0sq2kcfkkp9" />
          </div>
        </section>

        {/* Trust / Logo Strip */}
        <section className="mx-auto" data-id="element-3105" data-mp="183yubqz2syy">
          <p className="text-center text-xs md:text-sm font-medium text-gray-400 uppercase tracking-wider mb-4 md:mb-6" data-id="element-3106" data-mp="1b84ldk35wrq">
            Built by leaders from
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4 grayscale opacity-50" data-id="element-3107" data-mp="2q1sdefyv0swq">
            <img src="https://cdn.magicpatterns.com/uploads/nmqUJqLxx2VskE1njSdPet/Experian_logo.svg.png" alt="Experian" className="h-6 md:h-8 max-w-[100px] md:max-w-[120px] object-contain" data-id="element-3108" data-mp="2v37w41dkenby" />
            <img src="https://cdn.magicpatterns.com/uploads/fnXGBwy5K7uyX2UvFt6ups/Asana_logo.svg.png" alt="Asana" className="h-5 md:h-7 max-w-[80px] md:max-w-[100px] object-contain" data-id="element-3109" data-mp="27clpmej7lb42" />
            <img src="https://cdn.magicpatterns.com/uploads/jrBECYDpvuXUfYDgiVyTh2/drift_logo_fixed.png" alt="Drift" className="h-5 md:h-7 max-w-[70px] md:max-w-[90px] object-contain" data-id="element-3110" data-mp="2gb61avqcqkis" />
            <img src="https://cdn.magicpatterns.com/uploads/vjVVFtuWSA5UFtZmC7CMpG/Intel-Logo.png" alt="Intel" className="h-6 md:h-8 max-w-[60px] md:max-w-[70px] object-contain" data-id="element-3111" data-mp="1smmpi683fply" />
            <img src="https://cdn.magicpatterns.com/uploads/gifY524awm2QkgRHAkporM/NBCUniversal_2026_Logo.svg" alt="NBCUniversal" className="h-5 md:h-7 max-w-[110px] md:max-w-[140px] object-contain" data-id="element-3112" data-mp="1g5lshv5z6qyi" />
          </div>
        </section>
      </main>

      <footer className="bg-white border-t border-gray-200 py-6 md:py-8 mt-auto" data-id="element-3113" data-mp="125ayij9dcw94">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center text-xs md:text-sm text-gray-500" data-id="element-3114" data-mp="xdjaafdor2m5">
          <p data-id="element-3115" data-mp="sfrh7i1b1agd">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-1 md:mt-2 text-xs text-gray-400" data-id="element-3116" data-mp="ng5376dnjq6i">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}